import { pipeline } from "@figurepos/fgr-lib-business-logic/lib/common/functional"
import { flatten, isNil, map, reject } from "ramda"
import { MultiSelectItem, MultiSelectSearchMode } from "./MultiSelect"

export const flattenData = <TValue>(d: MultiSelectItem<TValue>[]) =>
    pipeline(
        d,
        map(i => [i, ...flattenData(i.children ?? [])]),
        flatten
    ) as MultiSelectItem<TValue>[]

export const filterSearchData = <TValue>(
    data: MultiSelectItem<TValue>[],
    search: string,
    searchMode?: MultiSelectSearchMode
): MultiSelectItem<TValue>[] => {
    const matches = (a: string, b: string) => a.trim().toLowerCase().includes(b.trim().toLowerCase())

    return pipeline(
        data,
        map(i => {
            const labelMatches = search && i.label ? matches(i.label, search.toLowerCase()) : true

            const children = i.children ?? []
            const filteredChildren = search && i.label ? filterSearchData(children, search, searchMode) : children

            if ((i.labelOnly || !labelMatches) && filteredChildren.length === 0) {
                return null
            }

            const childrenResult =
                searchMode === MultiSelectSearchMode.KeepChildren && labelMatches ? i.children : filteredChildren
            return {
                ...i,
                children: childrenResult?.length ? childrenResult : undefined,
            }
        }),
        reject(isNil)
    ) as MultiSelectItem<TValue>[]
}

export const isItemExpanded = <TValue extends string>(
    expandedData: Record<TValue, boolean>,
    itemId: TValue,
    collapseNested: boolean,
    searchValue: string
) => {
    // If collapsing nested items is disabled, keep all items expanded
    if (!collapseNested) {
        return true
    }
    // If the search is active, keep all items expanded
    if (searchValue) {
        return true
    }
    if (!!expandedData[itemId]) {
        return true
    }
    // By default, all items are collapsed
    return false
}
